import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchIntweviewModel = {
  id: string | number
  flag: boolean
}
type updateIntweviewModel = {
  id: string | number
}

export const fetchIntweview = ({ id, flag }: fetchIntweviewModel) => {
  return new ServicesUseCase(
    `/entrevista/load/${id}?flagEntrevista=${flag}`,
    makeAxiosHttpClient()
  )
}

export const updateIntweview = ({ id }: updateIntweviewModel) => {
  return new ServicesUseCase(`/entrevista/update/${id}`, makeAxiosHttpClient())
}
